{
  "placeholder": false,
  "items": [
    { "value": "2,000+", "label": "Active student users" },
    { "value": "4,000+", "label": "Bookings every month" },
    { "value": "30+", "label": "Registered vehicles" },
    { "value": "5", "label": "Campuses" }
  ]
}
